export default __webpack_public_path__ + "static/media/deleteRedIcon.d8ba0ca5.svg";